.modal {
  max-width: 650px !important;
}

.title {
  max-width: 525px;
  line-clamp: 1;
}
